/* eslint-disable unicorn/filename-case */
import { useCallback, useState } from 'react';

function useToggle(initialValue = false): {
  value: boolean;
  toggle: () => void;
  set: (value: boolean) => void;
} {
  const [value, setValue] = useState(initialValue);

  const toggle = useCallback(() => {
    setValue(prev => !prev);
  }, []);

  const set = useCallback((val: boolean) => {
    setValue(val);
  }, []);

  return { value, toggle, set };
}

export default useToggle;
